const save = ({ key, value }) => {
  localStorage.setItem(key, value);
};

const load = ({ key }) => localStorage.getItem(key);

export default {
  save,
  load,
};
